import {
    createLoaderUtils,
    initializeFiltersFromDOM,
    buildFilterUrl
} from './ajax-filters-shared.js';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.resources-with-filters').forEach(section => {

        const resultContainer = section.querySelector('.resource-results');
        const paginationWrapper = section.querySelector('.load-more-wrapper');
        const loadMoreBtn = section.querySelector('.load-more-resources');
        const countLabel = section.querySelector('.resource-total-count');
        const loader = section.querySelector('.loader');

        let currentPage = 1;

        let filters = {
            type: null,
            topic: null,
            author: null,
            tag: null,
            date: null,
        };

        // Initialize filters from currently selected options
        initializeFiltersFromDOM(section, filters);

        // Loader utils
        const loaderUtils = createLoaderUtils(loader);

        function fetchResources() {
            loaderUtils.show();

            const status = document.getElementById('resources-search-status');

            status.textContent = 'Loading results...';

            const data = new URLSearchParams({
                action: 'filter_resources',
                page: currentPage,
                type: filters.type || '',
                topic: filters.topic || '',
                author: filters.author || '',
                tag: filters.tag || '',
                date: filters.date || '',
            });

            fetch(ajax.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: data.toString(),
            })
                .then(res => res.json())
                .then(response => {
                    const data = response.data;

                    if (!data.html || data.html.trim() === '') {
                        resultContainer.innerHTML = '';
                        countLabel.innerHTML = 'No results found';
                        paginationWrapper.classList.add('hidden');
                        loadMoreBtn.classList.add('hidden');
                        status.textContent = 'No results found';
                        return;
                    }

                    // Insert new results
                    if (currentPage === 1) {
                        resultContainer.innerHTML = data.html;
                    } else {
                        // Append new results
                        resultContainer.insertAdjacentHTML('beforeend', data.html);
                    }

                    // Update the count label
                    countLabel.classList.remove('hidden');

                    const totalPages = data.total_pages;

                    // Show or hide the load more button
                    if (totalPages > currentPage) {
                        paginationWrapper.classList.remove('hidden');
                        loadMoreBtn.classList.remove('hidden');
                        currentPage++;
                        loadMoreBtn.setAttribute('data-page', currentPage);
                    } else {
                        paginationWrapper.classList.add('hidden');
                        loadMoreBtn.classList.add('hidden');
                    }
                })
                .catch(error => {
                    console.error('Error fetching resources:', error);
                    status.textContent = 'An error occurred while loading results';
                })
                .finally(() => {
                    loaderUtils.hide();
                });
        }

        // Event listeners for filter changes
        section.querySelectorAll('.custom-select__option').forEach(filter => {
            filter.addEventListener('click', function (e) {
                const value = e.target.dataset.value;
                const filterKey = e.target.dataset.filter;

                // Navigate to the appropriate URL for type and topic filters
                if (filterKey === 'type' || filterKey === 'topic') {
                    // Update the filter value
                    filters[filterKey] = value === 'all' ? null : value;

                    // Build and navigate to URL
                    const url = buildFilterUrl(filters, 'resources');
                    window.location.href = url;
                    return;
                }

                filters[filterKey] = (value === 'all') ? null : value;
                currentPage = 1;
                resultContainer.innerHTML = '';
                countLabel.innerHTML = '';
                loadMoreBtn.classList.add('hidden');
                fetchResources();
            });
        });

        // Load more
        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', (e) => {
                fetchResources();
            });
        }

        // Detect params in url
        const urlParams = new URLSearchParams(window.location.search);
        ['type', 'topic', 'author', 'tag', 'date'].forEach(key => {
            if (urlParams.has(key)) {
                const value = urlParams.get(key);
                filters[key] = value;
            }
        });

        // Fetch for url params
        if ([...urlParams.keys()].some(k => ['type', 'topic', 'author', 'tag', 'date'].includes(k))) {
            fetchResources();
        }
    });
});
